// ------------- import external dependencies --------------
import { instance } from "../instance";

/**
 * Get facilities in the system
 * @returns
 */
export const getFacilities = async () => {
  return instance({
    method: "get",
    url: `/facilities`,
  });
};

/**
 * Get roles in the system
 * @returns
 */
export const getRoles = async (id: string) => {
  return instance({
    method: "get",
    url: `/roles?profileId=${id}`,
  });
};

/**
 * Get profiles in the system
 * @returns
 */
export const getProfiles = async () => {
  return instance({
    method: "get",
    url: `/profiles`,
  });
};

/**
 * Delete user assignment
 */
export const deleteAssignment = async (data: any) => {
  return instance({
    method: "delete",
    url: `/facility`,
    data,
  });
};

/**
 * Handle add new assignment to user in a facility
 * @param data
 * @returns
 */
export const addNewFacilityAssignment = async (data: any) => {
  return instance({
    method: "post",
    url: "/facility",
    data,
  });
};
